<div class="addressbar">
  <span class="addresstext"> Podrška / Zahtjevi / Ispis</span>
</div>
<div class="containerpadding">
  <form (ngSubmit)="Ispisi()">
    <mat-card appearance="outlined">
      <mat-card-title>
        Ispis
      </mat-card-title>
      <mat-card-content>
        <div class="row">          
          <div class="col-lg-6 col-12">
            <mat-form-field appearance="fill" class="col-lg-6 col-12">
              <mat-label>Od dana</mat-label>
              <input matInput type="date-local" [matDatepicker]="dp1" [ngModel]="oddana | date:'yyyy-MM-dd'" (ngModelChange)="oddana=$event" placeholder="Od dana" name="oddana">
              <mat-datepicker-toggle matIconSuffix [for]="dp1"></mat-datepicker-toggle>
              <mat-datepicker #dp1></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="fill" class="col-lg-6 col-12">
              <mat-label>Do dana</mat-label>
              <input matInput type="date-local" [matDatepicker]="dp2" [ngModel]="dodana | date:'yyyy-MM-dd'" (ngModelChange)="dodana=$event" placeholder="Do dana" name="dodana">
              <mat-datepicker-toggle matIconSuffix [for]="dp2"></mat-datepicker-toggle>
              <mat-datepicker #dp2></mat-datepicker>
            </mat-form-field>
          </div>                   
        </div>
      </mat-card-content>
      <mat-card-actions class="text-center">
        <button mat-button type="submit" class="ok-color"><mat-icon aria-hidden="false" aria-label="Snimi">done</mat-icon>Ispiši</button>
      </mat-card-actions>
    </mat-card>
  </form>
  </div>
